<template>
<keep-alive>
    <div class="modal-mask">
        <div class="modal-wrapper">
            <div  class="modal_size sm_size">
                <a href="JavaScript:" class="ui_close" type="button" @click="$emit('close')"><span class="sr_only">popup close</span></a>
                <dl class="modal_content">
                    <dt class="ellipsis">
                        <i>{{$t('TITLE.CODEMNG.DETAIL.CODE.INFORMATION')}}</i>
                    </dt>
                    <dd>
                        <table class="create_table">
                        <colgroup>
                            <col width="32%" />
                            <col width="*" />
                        </colgroup>
                        <tbody>
                            <tr>
                                <th>{{$t('FIELD.CODEMNG.CODE')}}<em class="txt_mandatory">*</em></th>
                                <td>
                                    <span class="clearable">
                                    <input type="text" class="text_input w100" ref="codeId" v-model="codeId" :disabled="viewMode" maxlength="30" v-clearable />
                                    <i class="clearable_clear">X</i>
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <th>{{$t('FIELD.CODEMNG.CODE.NAME')}}</th>
                                <td>
                                    <span class="clearable">
                                    <input type="text" class="text_input w100" v-model="codeName" maxlength="1000" v-clearable />
                                    <i class="clearable_clear">X</i>
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <th>{{$t('FIELD.CODEMNG.UPPER.CODE')}}</th>
                                <td data-input-type="select">
                                    <select class="slt_white w100p" v-model="upperCode">
                                        <option value='' selected>{{$t('FIELD.CODEMNG.UPPER.CODE')}}</option>
                                    </select>
                                </td>
                            </tr>
                            <tr>
                                <th>{{$t('FIELD.GLOBAL.ORDER')}}</th>
                                <td>
                                    <span class="clearable">
                                    <input type="text" class="text_input w100" @keyup="onlyNumber($event)" v-model="order" v-clearable />
                                    <i class="clearable_clear">X</i>
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <th>{{$t('FIELD.GLOBAL.STATUS')}}</th>
                                <td>
                                    <select class="slt_white w100p" v-model="status">
                                        <option value='' selected>Status</option>
                                        <option value='A'>{{$t('FIELD.GLOBAL.ACTIVE')}}</option>
                                        <option value='S'>{{$t('FIELD.GLOBAL.SLEEP')}}</option>
                                    </select>
                                </td>
                            </tr>
                        </tbody>
                        </table>
                        <div class="btn_modal_wrap topLine">
                            <div class="btn_right">
                                <a href="JavaScript:" class="btn_white" @click="$emit('close')">{{$t('BUTTON.GLOBAL.CANCEL')}}</a>
                                <a href="JavaScript:" class="btn_blue" @click="detlCodeSave()">{{$t('BUTTON.GLOBAL.SAVE')}}</a>
                            </div>
                        </div>
                    </dd>
                </dl>
            </div>
        </div>
    </div>
</keep-alive>
</template>
<script>
import Vue          from 'vue';
import qs           from 'query-string';
import axios        from 'axios';
import { SDLUtil }  from '@/utils';
import { EventBus } from '@/utils/EventBus';

export default {
    name: 'ExcelDownloadPopup',
    props: {
        title: {},
        pCategoryId: '',
        detlCodes : {}
    },
    data() {
        return {
            categoryId : this.pCategoryId,
            viewMode : false,
            codeId : '',
            codeName: '',
            upperCode: '',
            order: 0,
            status: 'A'
        }
    },
    methods: {
        detlCodeyValidateion() {
            let bRes = true;
            let valids = [this.codeId, this.codeName, this.status];
            let titles = ['Code', 'Code Name', 'Status'];
            $.each(valids, function(idx, elm) {
                if (!elm) {
                    bRes = false;
                    SDLUtil.alert('Empty value of [' + titles[idx] + ']');
                    return;
                }
            });
            return bRes;
        },
        onlyNumber(e) { SDLUtil.onlyNumber(e); },
        detlCodeSave() {
            let formData = { 
                codeCategoryId : this.categoryId,
                code : this.codeId,
                codeDesc : this.codeName,
                parentCode : this.upperCode,
                sortOrder : this.order,
                statusCode : this.status,
                isUpdate : (this.detlCodes ? true : false)
            };
            if (!this.detlCodeyValidateion()) {
                return;
            }
            return axios
                .post(
                    `${SDLUtil.API_URL}/basis/admin/system/code/codeDetailSave.skp`,
                    qs.stringify(formData), {
                        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
                    }
                )
                .then((resp) => {
//                    console.log('resp ===> ', resp);
                    if (resp.data.result == 1) {
                        SDLUtil.getMsgProp('MESSAGE.SUCCESS.SAVED'), {
                            theme: "toasted-primary",
                            position: "top-center",
                            duration : 3000
                        }
                        EventBus.$emit('refresh', 2);
                        this.$emit('close');
                    }
            });
        }
    },
    mounted() {
//        console.log('this.detlCodes ==> ', this.detlCodes);
        if (this.detlCodes) { // 수정모드
            this.viewMode = true;
            this.codeId = this.detlCodes.code;
            this.codeName = this.detlCodes.codeDesc;
            this.upperCode = this.detlCodes.upperCodeId;
            this.order = this.detlCodes.sortOrder;
            this.status = this.detlCodes.statusCode;
        } else { // 신규모드
            this.$refs.codeId.focus();
        }
    }

};
</script>


// WEBPACK FOOTER //
// src/skpComponents/view/admin/system/code/CodeDetlPopup.vue